import { HttpMethod } from '@nu-art/thunderstorm-shared';
export const ApiDef_Coralogix = {
    v1: {
        sendTelemetry: { method: HttpMethod.POST, path: '/v1/coralogix/send-telemetry' },
    }
};
//# sourceMappingURL=apis.js.map